import { render, staticRenderFns } from "./EventSourcesPlugin.vue?vue&type=template&id=5f6048b3&"
import script from "./EventSourcesPlugin.vue?vue&type=script&lang=ts&"
export * from "./EventSourcesPlugin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports